import { render, staticRenderFns } from "./BetgameEditBetview.vue?vue&type=template&id=54b05651&scoped=true"
import script from "./BetgameEditBetview.vue?vue&type=script&lang=js"
export * from "./BetgameEditBetview.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditBetview.vue?vue&type=style&index=0&id=54b05651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b05651",
  null
  
)

export default component.exports